type LanguageIcons = Record<string, string>;

const languageIconModules = import.meta.glob('../assets/lang/*.svg', {
    eager: true,
    query: '?url',
    import: 'default',
}) as Record<string, string>;

export const getLanguageIcons = (): LanguageIcons => {
    const languageIcons: LanguageIcons = {};
    for (const path in languageIconModules) {
        const lang = path.replace(/^.*\//, '').replace(/\.svg$/, '');
        languageIcons[lang] = languageIconModules[path];
    }

    return languageIcons;
};
